<template>

  <!-- app-layer {admin} -->
  <div class="app-layer admin" @click="layerClick($event)">

    <transition name="right-modal" v-show="show">

      <div class="modal-custom right" name="media-info" v-if="show" :class="{loading: loading}">

        <span class="close" @click="closeModal()">chiudi</span>

        <div class="content">

        <h2 class="mt-0">Informazioni file</h2>

        <img class="media-img" :src="preview" />

          <div class="info">

            <section>
              <label for="">Nome file</label>
              <span>{{media.nome}}</span>
            </section>

            <section>
              <label for="">Estensione file</label>
              <span>{{media.estensione}}</span>
            </section>

            <section>
              <label for="">Cartella</label>
              <span>/{{media.cartella}}</span>
            </section>

            <section>
              <label for="">MimeType</label>
              <span>{{media.mime_type}}</span>
            </section>

            <section>
              <label for="">Peso del file</label>
              <span>{{media.peso_formattato}}</span>
            </section>

            <section>
              <label for="">Classe del file</label>
              <span>{{fileClass}}</span>
            </section>

            <section>
              <label for="">Data e ora caricamento</label>
              <span>{{media.created_at}}</span>
            </section>

          </div>

        </div>

      </div>

    </transition>

  </div>

</template>

<script>
export default{

  props: ['media'],

  data: function(){

    return {

      loading: false,
      show: false,
      // ... modal data
      images: ['jpeg', 'jpg', 'png', 'svg', 'gif'],
      documents: ['pdf', 'docx', 'txt', 'csv', 'xmls'],
      document_preview: window.location.origin + '/media/document_placeholder.jpg'

    }

  },

  computed: {

    preview: function(){

      if( _.indexOf( this.images, this.media.estensione ) > -1 ){
        return this.media.url;
      } else{
        return this.document_preview;
      }

    },

    fileClass: function(){

      return this.media.collezione == 'image' ? 'Immagine' : 'Documento'

    }

  },

  methods: {

    layerClick: function(event){

      if( event.target.classList.contains('app-layer') ) this.closeModal();

    },

    // manage close animation
    closeModal: function(){

      this.show = false;
      setTimeout(function(vue){
        vue.$destroy();
      }, 400, this);

    },

  },

  mounted: function(){

    // show component
    this.show = true;

  },

  // send modal destry to other components
  destroyed: function(){

    this.$parent.show_info = false;

  }

}
</script>

<style scoped>
.modal-custom{
  background-color: white;
  max-width: 800px;
}
.modal-custom .content{
  margin-bottom: 3em;
}
img.media-img{
  margin: 0 auto 2em auto;
  max-height: 40vh;
  width: auto;
}
.info{
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.info section{
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 15px;
}
.info section:nth-child(odd){
  background-color: var(--background-gray-2);
}
.info section label,
.info section span{
  width: 50%;
  font-size: .9em;
}
.info section span{
  font-weight: bold;
}
</style>
